import { render, staticRenderFns } from "./pictures.vue?vue&type=template&id=fcf00098&scoped=true&"
import script from "./pictures.vue?vue&type=script&lang=ts&"
export * from "./pictures.vue?vue&type=script&lang=ts&"
import style0 from "./pictures.vue?vue&type=style&index=0&id=fcf00098&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcf00098",
  null
  
)

export default component.exports